import {HOMEPAGE_PATH} from 'nav/sidepanel/homepage/HomepageConstants';

// TODO: Add other url patterns
const HOMEPAGE_URL_PATTERN = HOMEPAGE_PATH.slice(1);

function urlPatternToPageUrlAllowlistRegex(urlPattern: string): RegExp {
  const pathPattern = urlPattern.replace(/:[^/]+/g, '[^/]+');
  return new RegExp(`/${pathPattern}(?:/|$|\\?|#)`);
}

/** Page URL patterns where Amplitude AutoCapture is enabled */
export function getAmplitudePageUrlAllowlist(): Array<RegExp> {
  return [urlPatternToPageUrlAllowlistRegex(HOMEPAGE_URL_PATTERN)];
}
